import {useEffect, useState} from 'react';

import {getFirstStepCidForMethod} from 'procedures/design/step-config/stepManagementUtils';
import {Method} from 'procedures/ProcedureDomainTypes';

export interface UseSelectedStepOutputs {
  selectedStepCid: string | null;
  onChangeSelectedStep: (stepCid: string) => void;
}

/**
 * Simple tool to keep track of the selected step for each method in the procedure.
 */
export default function useSelectedStep(method: Method): UseSelectedStepOutputs {
  const [selectedStepCid, setSelectedStepCid] = useState(getFirstStepCidForMethod(method));

  // When the selected method changes, recalculate the default selected step
  useEffect(() => {
    setSelectedStepCid(getFirstStepCidForMethod(method));
    // We only want to run when the selected method changes (i.e., we get a new CID), not when the method object changes
    // oxlint-disable-next-line exhaustive-deps
  }, [method.cid]);

  return {
    selectedStepCid,
    onChangeSelectedStep: setSelectedStepCid,
  };
}
